<div class="flex flex-row justify-between">
   <div class="flex-initial text-left">
      <img *ngIf="data.icon == 'check'; else showError" class="mr-2" width="25" src="/assets/img/icons/check.png">
      <ng-template #showError>
         <img class="mr-2" width="25" src="/assets/img/icons/error.png">
      </ng-template>
   </div>
   <div class="flex-1" style="position: relative; top: -5px">
      <div class="font-bold text-lg" *ngIf="title">{{title}}</div>

      <div *ngIf="msg;">
         {{msg}}
         <br *ngIf="subMsg">{{subMsg}}
      </div>

      <div *ngIf="html" >
         <div [innerHTML]="html"></div>
         <br *ngIf="subMsg">{{subMsg}}
      </div>

   </div>

   <div class="flex-initial text-right">
      <button (click)="snackBarRef.dismiss()" aria-label="Clear" >
         <mat-icon>close</mat-icon>
      </button>
   </div>
</div>

<div class="flex flex-row justify-center mt-5" *ngIf="actionButton">
   <button class="btn-ibm-sm-secondary-outline" (click)="actionButton.onClick(); dismiss()">
      <span class="">{{actionButton.text}}</span>
   </button>
</div>
